import './tabs-menu.scss'

import { defineComponent, PropType } from 'vue';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const SELECTED_TAB_CHANGE_EVENT = 'selected-item-changed'

export interface TabsMenuEntry {
    title: string
    dataCy?: string
}

export const TabsMenu = defineComponent({
    mixins: [reactiveVueMixin],
    props: {
        selectedIndex: {
            type: Number,
        },
        entries: {
            type: Array as PropType<TabsMenuEntry[]>,
        },
    },
    template: require('./tabs-menu.html'),
    methods: {
        isSelected(index: number) {
            return index === this.selectedIndex
        },
        onTabClicked(index: number) {
            if(index !== this.selectedIndex) {
                this.$emit(SELECTED_TAB_CHANGE_EVENT, index)
            }
        },
    },
})
